import { getDealStatusLabel } from "./dealStatusLabels";
import {
  formatDateTimeUk,
  partyDisplayName,
} from "./dealFormatting";

export const DEAL_EVENT_TYPE_LABELS = {
  proposal_created: "Пропозицію створено",
  internal_started: "Внутрішню угоду розпочато",
  accepted: "Пропозицію прийнято",
  declined: "Пропозицію відхилено",
  withdrawn: "Пропозицію відкликано",
  cancelled: "Угоду скасовано",
  closed: "Угоду закрито",
  legacy_backfill: "Історичний запис",
};

/**
 * Chronological DealEvent rows for the detail timeline.
 * Unknown/legacy types fall back safely without crashing.
 */
export function formatDealEventForTimeline(event) {
  if (!event || typeof event !== "object") {
    return {
      id: null,
      title: "Подія угоди",
      timeLabel: "—",
      actorLabel: null,
      transitionLabel: null,
      note: null,
    };
  }

  const type = event.event_type;
  const title =
    DEAL_EVENT_TYPE_LABELS[type]
    || (typeof type === "string" && type
      ? `Подія: ${type}`
      : "Невідома подія");

  const previous = event.previous_status
    ? getDealStatusLabel(event.previous_status)
    : null;
  const next = event.new_status ? getDealStatusLabel(event.new_status) : null;
  let transitionLabel = null;
  if (previous && next) {
    transitionLabel = `${previous} → ${next}`;
  } else if (next) {
    transitionLabel = next;
  }

  const metadata =
    event.metadata && typeof event.metadata === "object" ? event.metadata : {};
  const reason =
    typeof metadata.reason === "string" ? metadata.reason.trim() : "";
  const note = reason || null;

  return {
    id: event.id,
    title,
    timeLabel: formatDateTimeUk(event.created_at),
    actorLabel: event.actor ? partyDisplayName(event.actor) : null,
    transitionLabel,
    note,
  };
}

export function sortDealEventsChronologically(events) {
  const list = Array.isArray(events) ? [...events] : [];
  return list.sort((a, b) => {
    const aTime = a && a.created_at ? Date.parse(a.created_at) : 0;
    const bTime = b && b.created_at ? Date.parse(b.created_at) : 0;
    if (aTime !== bTime) return aTime - bTime;
    const aId = a && a.id != null ? Number(a.id) : 0;
    const bId = b && b.id != null ? Number(b.id) : 0;
    return aId - bId;
  });
}
